export default __webpack_public_path__ + "static/media/atmCard.cb526d19.svg";